import { FC, useMemo } from "react";
import { headData } from "../../utils/mockData/searchMocks";
import HeadSection from "../common/HeadSection";

const ToursDestinationsHead: FC<{ numberFilteredPackage: number }> = ({
    numberFilteredPackage,
}) => {
    const updatedHeadData = useMemo(() => {
        headData.subTitle[0].text = `${numberFilteredPackage} tours found`;
        return headData;
    }, [numberFilteredPackage]);

    return <HeadSection content={updatedHeadData} />;
};

export default ToursDestinationsHead;
